import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Actions from './actions';
import Edit from './edit';
import Delete from './delete';

const Row = ({ data, fetchData }) => {
  const { id, name } = data;
  const [mode, setMode] = useState({
    edit: false,
    delete: false
  });

  return (
    <>
      <tr>
        {mode.delete && (
          <td colSpan={2}>
            <Delete
              id={id}
              name={name}
              mode={mode}
              setMode={setMode}
              fetchData={fetchData}
            />
          </td>
        )}
        {mode.edit && (
          <td colSpan={2}>
            <Edit
              id={id}
              name={name}
              mode={mode}
              setMode={setMode}
              fetchData={fetchData}
            />
          </td>
        )}
        {!mode.edit && !mode.delete && (
          <>
            <td
              style={{
                textAlign: 'center',
                fontWeight: '500',
                borderRight: '1px solid #e7e7e7'
              }}
            >
              {name}
            </td>
            <td>
              <Actions mode={mode} setMode={setMode} />
            </td>
          </>
        )}
      </tr>
    </>
  );
};

Row.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    formTypes: PropTypes.shape({})
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Row;
